export const FORM_RESPONSE_LIST_REQUEST = 'FORM_RESPONSE_LIST_REQUEST';
export const FORM_RESPONSE_LIST_SUCCESS = 'FORM_RESPONSE_LIST_SUCCESS';
export const FORM_RESPONSE_LIST_FAIL = 'FORM_RESPONSE_LIST_FAIL';
export const FORM_RESPONSE_LIST_RESET = 'FORM_RESPONSE_LIST_RESET';

export const FORM_RESPONSE_DETAILS_REQUEST = 'FORM_RESPONSE_DETAILS_REQUEST';
export const FORM_RESPONSE_DETAILS_SUCCESS = 'FORM_RESPONSE_DETAILS_SUCCESS';
export const FORM_RESPONSE_DETAILS_FAIL = 'FORM_RESPONSE_DETAILS_FAIL';

export const FORM_RESPONSE_CREATE_REQUEST = 'FORM_RESPONSE_CREATE_REQUEST';
export const FORM_RESPONSE_CREATE_SUCCESS = 'FORM_RESPONSE_CREATE_SUCCESS';
export const FORM_RESPONSE_CREATE_FAIL = 'FORM_RESPONSE_CREATE_FAIL';
export const FORM_RESPONSE_CREATE_RESET = 'FORM_RESPONSE_CREATE_RESET';

export const FORM_RESPONSE_UPDATE_REQUEST = 'FORM_RESPONSE_UPDATE_REQUEST';
export const FORM_RESPONSE_UPDATE_SUCCESS = 'FORM_RESPONSE_UPDATE_SUCCESS';
export const FORM_RESPONSE_UPDATE_FAIL = 'FORM_RESPONSE_UPDATE_FAIL';
export const FORM_RESPONSE_UPDATE_RESET = 'FORM_RESPONSE_UPDATE_RESET';

export const FORM_RESPONSE_DELETE_REQUEST = 'FORM_RESPONSE_DELETE_REQUEST';
export const FORM_RESPONSE_DELETE_SUCCESS = 'FORM_RESPONSE_DELETE_SUCCESS';
export const FORM_RESPONSE_DELETE_FAIL = 'FORM_RESPONSE_DELETE_FAIL';
export const FORM_RESPONSE_DELETE_RESET = 'FORM_RESPONSE_DELETE_RESET';

export const FORM_RESPONSE_BY_PATIENT_REQUEST = 'FORM_RESPONSE_BY_PATIENT_REQUEST';
export const FORM_RESPONSE_BY_PATIENT_SUCCESS = 'FORM_RESPONSE_BY_PATIENT_SUCCESS';
export const FORM_RESPONSE_BY_PATIENT_FAIL = 'FORM_RESPONSE_BY_PATIENT_FAIL';

export const FORM_RESPONSE_LIST_BYIDS_REQUEST = 'FORM_RESPONSE_LIST_BYIDS_REQUEST';
export const FORM_RESPONSE_LIST_BYIDS_SUCCESS = 'FORM_RESPONSE_LIST_BYIDS_SUCCESS';
export const FORM_RESPONSE_LIST_BYIDS_FAIL = 'FORM_RESPONSE_LIST_BYIDS_FAIL';
export const FORM_RESPONSE_LIST_BYIDS_RESET = 'FORM_RESPONSE_LIST_BYIDS_RESET';

export const FORM_RESPONSE_DTO_REQUEST = 'FORM_RESPONSE_DTO_REQUEST';
export const FORM_RESPONSE_DTO_SUCCESS = 'FORM_RESPONSE_DTO_SUCCESS';
export const FORM_RESPONSE_DTO_FAIL = 'FORM_RESPONSE_DTO_FAIL';
export const FORM_RESPONSE_DTO_RESET = 'FORM_RESPONSE_DTO_RESET';

